import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import API_BASE_URL from "../config/baseUrl";
import { getAccessToken } from "../store/actions/auth";
import { useGetUserBalanceQuery, useUpdateUserBalanceMutation } from "../services/auth/authApi";
import { getSiteName } from "../utils/domainConfig";

const TransactionModal = ({ isOpen, onClose, type, user, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  // Use RTK Query to fetch balance
  const { data: balanceData, isLoading: balanceLoading, error: balanceError } = useGetUserBalanceQuery(
    user?.id,
    { skip: !isOpen || !user?.id }
  );

  // Use RTK Query mutation for balance update
  const [updateBalance] = useUpdateUserBalanceMutation();

  if (!isOpen || !user) return null;

  const isDeposit = type === "deposit";
  const title = isDeposit ? "Deposite Chips" : "Withdrawn Chips";

  // Use balance from API response
  const currentChips = balanceData?.data?.currentCoins !== undefined
    ? balanceData.data.currentCoins 
    : (user.balance || 0) + (user.balanceWithPnl || 0);
    const handleSubmit = async function () {
  
    // const numAmount = parseFloat(amount);
    // if (!numAmount || isNaN(numAmount) || numAmount <= 0) {
    //   toast.error("Please enter a valid amount");
    //   return;
    // }

    setLoading(true);
const depositeType = type =="deposit"?"credit" : "debit";
    try {
 
      const result = await updateBalance({
        userId: user.id,
        amount: Number(amount),
        type: depositeType // 'deposit' or 'withdraw'
      }).unwrap();

    
      setAmount("");
      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleClose = function () {
    setAmount("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[5vh]">
      <div className="fixed inset-0 bg-black/50" onClick={handleClose}></div>
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-lg mx-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-[#2c3e50] text-white rounded-t-lg">
          <h3 className="text-xl font-normal">
            <span className="font-bold">{getSiteName()}</span> {title}
          </h3>
          <button
            onClick={handleClose}
            className="text-white hover:text-gray-300 text-3xl leading-none"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-4">
          {/* Current Coins Display */}
          <div className="text-2xl text-gray-700 mb-4">
            Curr Coins : {balanceLoading ? (
              <span className="inline-block animate-pulse">Loading...</span>
            ) : (
              currentChips.toFixed(2)
            )}
          </div>

          {/* Amount Input */}
          <input
            type="text"
            value={amount}
            onChange={function (e) {
              setAmount(e.target.value);
            }}
            placeholder="chips"
            className="w-full px-4 py-3 text-lg border border-gray-300 focus:outline-none focus:border-gray-400"
          />
        </div>

        {/* Footer */}
        <div className="px-6 py-4 flex justify-end gap-3">
          <button
            onClick={handleClose}
            className="px-8 py-2 bg-[#546e7a] text-white hover:bg-[#455a64] transition-colors"
          >
            Return
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !amount}
            className="px-8 py-2 bg-[#2196f3] text-white hover:bg-[#1976d2] disabled:bg-gray-300 transition-colors"
          >
            {loading ? "Processing..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionModal;
